import isPostalCodeValidator, {
  PostalCodeLocale,
} from 'validator/lib/isPostalCode'

export const isPostalCode = (locale: PostalCodeLocale) => ({
  postalCode: (value: string) => {
    return !value || isPostalCodeValidator(value, locale)
  },
})
